import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14409">
      <span className="sr-only" data-id="element-14410">Loading details…</span>
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-14411">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-14412" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-14413" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14414">
        <div className="flex items-start gap-4 mb-6" data-id="element-14415">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-14416" />
          <div className="flex-1" data-id="element-14417">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-14418" />
            <div className="space-y-2" data-id="element-14419">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-14420" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-14421" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-14422" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-14423" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-14424">
          {[1, 2, 3].map(i => <div key={i} data-id="element-14425">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-14426" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-14427" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-14428">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-14429">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-14430">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14431" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-14432">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-14433">
              <div className="flex justify-between items-center" data-id="element-14434">
                <div className="flex-1 space-y-2" data-id="element-14435">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-14436" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-14437" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14438" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}